module.exports = __webpack_public_path__ + "static/media/emblem_white.696638a1.png";